import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=267c88e5"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports